import { render } from "./BarCode.vue?vue&type=template&id=5ad80308&scoped=true"
import script from "./BarCode.vue?vue&type=script&lang=js"
export * from "./BarCode.vue?vue&type=script&lang=js"

import "./BarCode.vue?vue&type=style&index=0&id=5ad80308&scoped=true&lang=css"

import exportComponent from "/home/ysm/workspace/webtool/www-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ad80308"]])

export default __exports__